import * as React from 'react';
import { CheckoutOrderFragment } from '@websky/graphql';

interface RefundServicesContextProps {
	updateOrder: () => Promise<CheckoutOrderFragment>;
}

const RefundServicesContext = React.createContext<RefundServicesContextProps>(null);

export const useRefundServices = () => React.useContext(RefundServicesContext);

const RefundServicesProvider: React.FC<RefundServicesContextProps> = ({ children, ...props }) => {
	return <RefundServicesContext.Provider value={props}>{children}</RefundServicesContext.Provider>;
};

export default RefundServicesProvider;
